import { BadRequestException } from '@nestjs/common';

/**
 * An exception that indicates insufficient data was found to perform the requested operation.
 * This typically occurs when querying data sources that require a minimum threshold of records
 * for statistical analysis or recommendations.
 *
 * @example
 * throw new LimitedDataError({
 *   cause: new Error('Not enough sales comps found in the area')
 * });
 */
export const LimitedDataErrorMessage = 'Limited data';
export class LimitedDataError extends Error {
  constructor(options?: ErrorOptions) {
    super(LimitedDataErrorMessage, options);
    this.name = 'LimitedDataError';
  }
}

/**
 * An exception that indicates the list price is required to perform the requested operation.
 * This typically occurs when querying data sources that require a list price to perform statistical analysis or recommendations.
 *
 * @example
 * throw new MissingListPriceError({
 *   cause: new Error('List price is required')
 * });
 */
export const MissingListPriceErrorMessage =
  'LISTING_REPORT_LIST_PRICE_REQUIRED';
export class MissingListPriceError extends BadRequestException {
  constructor(options?: ErrorOptions) {
    super(MissingListPriceErrorMessage, options);
    this.name = 'MissingListPriceError';
  }
}

export class AddressExtractionError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'AddressExtractionError';
  }
}

export class MLSListingSearchError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'MLSListingSearchError';
  }
}

export class ListingReportGenerationError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'ListingReportGenerationError';
  }
}
